<script>
import axios from "axios";
import { toast, variants } from "@/helpers/toaster";

export default {
  name: "CityExpressSenderForm",
  props: {
    sender: { type: Object, default: null },
  },
  data() {
    return {
      saving: false,
      form: this.blankForm(),
    };
  },
  watch: {
    sender: {
      immediate: true,
      handler(val) {
        this.form = val ? { ...this.blankForm(), ...val } : this.blankForm();
      },
    },
  },
  methods: {
    blankForm() {
      return {
        ce_sender_id: null,
        name: "",
        street_and_number: "",
        zipcode: "",
        city: "",
        country_code: "RS",
        contact_name: "",
        phone: "",
        email: "",
        is_default: false,
      };
    },
    async submit() {
      this.saving = true;
      try {
        const payload = { ...this.form };
        if (this.sender && this.sender.id) {
          await axios.put(
            `/super-admin/city-express/senders/${this.sender.id}`,
            payload,
          );
          toast("Pošiljalac sačuvan.", variants.SUCCESS);
        } else {
          await axios.post("/super-admin/city-express/senders", payload);
          toast("Pošiljalac kreiran.", variants.SUCCESS);
        }
        this.$emit("saved");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<template>
  <b-form @submit.prevent="submit()">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Naziv *</label>
          <b-form-input v-model="form.name" maxlength="35" required />
        </div>
        <div class="form-group">
          <label>Adresa *</label>
          <b-form-input
            v-model="form.street_and_number"
            maxlength="70"
            required
          />
        </div>
        <div class="row">
          <div class="col-4">
            <div class="form-group">
              <label>PB *</label>
              <b-form-input v-model="form.zipcode" maxlength="10" required />
            </div>
          </div>
          <div class="col-8">
            <div class="form-group">
              <label>Grad *</label>
              <b-form-input v-model="form.city" maxlength="35" required />
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>Država (ISO-2) *</label>
          <b-form-input v-model="form.country_code" maxlength="2" required />
        </div>
      </div>

      <div class="col-md-6">
        <div class="form-group">
          <label>Kontakt osoba</label>
          <b-form-input v-model="form.contact_name" maxlength="255" />
        </div>
        <div class="form-group">
          <label>Telefon</label>
          <b-form-input v-model="form.phone" maxlength="30" />
        </div>
        <div class="form-group">
          <label>Email</label>
          <b-form-input v-model="form.email" type="email" maxlength="70" />
        </div>
        <div class="form-group">
          <label>City Express ID</label>
          <b-form-input v-model.number="form.ce_sender_id" type="number" />
          <small class="text-muted">
            Postavlja se automatski prilikom sinhronizacije iz CE.
          </small>
        </div>
        <div class="form-group">
          <b-form-checkbox v-model="form.is_default">
            Postavi kao podrazumevanog pošiljaoca
          </b-form-checkbox>
        </div>
      </div>
    </div>

    <div class="text-right mt-3">
      <b-button variant="secondary" @click="$emit('cancel')" :disabled="saving">
        Otkaži
      </b-button>
      <b-button type="submit" variant="primary" class="ml-2" :disabled="saving">
        {{ saving ? "Čuvanje…" : "Snimi" }}
      </b-button>
    </div>
  </b-form>
</template>
